import { render } from "./CompanyInformation.vue?vue&type=template&id=45a534e7&scoped=true"
import script from "./CompanyInformation.vue?vue&type=script&lang=js"
export * from "./CompanyInformation.vue?vue&type=script&lang=js"

import "./CompanyInformation.vue?vue&type=style&index=0&id=45a534e7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a534e7"]])

export default __exports__